import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'

document.fonts.ready.then(() => {
  document.body.classList.add('fonts-loaded')
})

const app = mount(App, {
  target: document.getElementById('app')!,
})

export default app
